function getModuleIcon(type: string): string {
    switch (type) {
        case 'user':
            return 'icon-user-color.png'
        case 'group':
            return 'icon-group-color.png'
        case 'operation':
            return 'icon-building-color.png'
    }
}

export { getModuleIcon }
